import { render } from "./FichaProducto.vue?vue&type=template&id=199f9486&scoped=true"
import script from "./FichaProducto.vue?vue&type=script&lang=js"
export * from "./FichaProducto.vue?vue&type=script&lang=js"

import "./FichaProducto.vue?vue&type=style&index=0&id=199f9486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199f9486"]])

export default __exports__